module.exports = __webpack_public_path__ + "static/calling-in-counseling-ecda046091b63c94fbca2889b88047ff.jpg";